import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/pages/Login'
import Home from '@/components/pages/Home'
import Front from '@/components/pages/Front'
import User from '@/components/pages/User'
import Power from '@/components/pages/Power'
import OperationLog from '@/components/pages/OperationLog'
import UserAudit from '@/components/pages/UserAudit'
import ContentAudit from '@/components/pages/ContentAudit'
import ImgAudit from '@/components/pages/ImgAudit'
import WebsiteStatistics from '@/components/pages/WebsiteStatistics'
import ContentStatistics from '@/components/pages/ContentStatistics'
import SensitiveSet from '@/components/pages/SensitiveSet'
import NotFound from '@/components/pages/NotFound'
import Admin from '@/components/pages/Admin'
import Role from '@/components/pages/Role'
import Sku from '@/components/pages/Sku'
import Spu from '@/components/pages/Spu'
import Content from '@/components/pages/Content'
import Specs from '@/components/pages/Specs'
import Options from '@/components/pages/Options'
import PerInfo from '@/components/pages/PerInfo'
import ReSetPWD from '@/components/pages/ReSetPWD'
import Channels from '@/components/pages/Channels'
import Brands from '@/components/pages/Brands'
import Pictures from '@/components/pages/Pictures'
import SpuAdd from '@/components/pages/SpuAdd'
import SpuEdit from '@/components/pages/SpuEdit'
import Order from '@/components/pages/Order'
import OrderDetail from '@/components/pages/OrderDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      children:[
          {
            path:'/home',
            name: 'Front',
            component: Front
          },
          {
            path:'/home/front',
            name: 'Front',
            component: Front
          },
          // {
          //   path:'/home/user',
          //   name: 'User',
          //   component: User
          // },
          // {
          //   path:'/home/content',
          //   name:'Content',
          //   component:Content
          // },
          // {
          //   path:'/home/userAudit',
          //   name:'UserAudit',
          //   component:UserAudit
          // },
          {
            path:'/home/contentAudit',
            name:'ContentAudit',
            component:ContentAudit
          },
          // {
          //   path:'/home/imgAudit',
          //   name:'ImgAudit',
          //   component:ImgAudit
          // },
          // {
          //   path:'/home/sensitiveSet',
          //   name:'SensitiveSet',
          //   component:SensitiveSet
          // },
          // {
          //   path:'/home/websiteStatistics',
          //   name:'WebsiteStatistics',
          //   component:WebsiteStatistics
          // },
          // {
          //   path:'/home/contentStatistics',
          //   name:'ContentStatistics',
          //   component:ContentStatistics
          // },
          // {
          //   path:'/home/role',
          //   name: 'Role',
          //   component: Role
          // },
          // {
          //   path:'/home/admin',
          //   name: 'Admin',
          //   component: Admin
          // },
          // {
          //   path:'/home/power',
          //   name: 'Power',
          //   component: Power
          // },
          // {
          //   path:'/home/operationLog',
          //   name: 'OperationLog',
          //   component: OperationLog
          // },
          // {
          //   path:'/home/perInfo',
          //   name: 'PerInfo',
          //   component: PerInfo
          // },
          // {
          //   path:'/home/reSetPWD',
          //   name: 'ReSetPWD',
          //   component: ReSetPWD
          // },

          // {
          //   path:'/home/sku',
          //   name: 'Sku',
          //   component: Sku
          // },
          // {
          //   path:'/home/spu',
          //   name:'Spu',
          //   component:Spu
          // },
          // {
          //   path:'/home/specs',
          //   name:'Specs',
          //   component:Specs
          // },
          // {
          //   path:'/home/options',
          //   name:'Options',
          //   component:Options
          // },
          // {
          //   path:'/home/channels',
          //   name:'Channels',
          //   component:Channels
          // },

          // {
          //   path:'/home/brands',
          //   name:'Brands',
          //   component:Brands
          // },
          // {
          //   path:'/home/pictures',
          //   name:'Pictures',
          //   component:Pictures
          // },
          // {
          //   path:'/home/spuadd',
          //   name:'SpuAdd',
          //   component:SpuAdd
          // },
          // {
          //   path:'/home/spuedit',
          //   name:'SpuEdit',
          //   component:SpuEdit
          // },
          // {
          //   path:'/home/order',
          //   name:'Order',
          //   component:Order
          // },
          // {
          //   path:'/home/order_detail',
          //   name:'OrderDetail',
          //   component:OrderDetail
          // }
      ]
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js